import {kAboutMissionTexts} from "../../../constants/texts";
import {aboutScreenHighlightWords} from "../../../helpers/StringHelper";
import {kAboutScreenImages} from "../../../constants/images";

export default function AboutMissionSection({goToMethod}) {
    // Used in AboutContent to display mission related content
    // in desktop / tablet mode

    // BUILD
    return(
        <div className={"w-full flex flex-col justify-start items-center pb-[24px] pt-[40px]"}>
            <div className={"w-full flex justify-start items-start space-x-[32px]"}>
                <div className={`h-[224px] min-h-[224px] min-w-[200px] flex justify-center items-center`}>
                    <img className={"object-contain h-full -mt-[16px]"}
                         src={kAboutScreenImages.missionFox}
                         alt="Mission"/>
                </div>
                <div className={"flex flex-col justify-start items-start space-y-[12px]"}>
                    <span className={"text-[20px] text-white font-medium"}>
                        {kAboutMissionTexts.intro}
                    </span>
                    <span className={"text-[18px] text-greyLight9 font-normal"}>
                        {aboutScreenHighlightWords(kAboutMissionTexts.missionOne, ['étoile polaire', 'guide', 'aider chaque élève', 'comprendre', 'progresser', 'réussir'])}
                    </span>
                </div>
            </div>
            <div className={"mt-[16px] text-[18px] text-greyLight9 font-normal"}>
                <span className={""}>
                    {aboutScreenHighlightWords(kAboutMissionTexts.missionTwo, ['cumulative', 'maîtriser les fondamentaux', 'bases solides', 'durables'])}
                </span>
                <span className={"cursor-pointer text-primaryLight1 hover:underline"}
                      onClick={goToMethod}>
                    {kAboutMissionTexts.overHere}
                </span>
                <span className={""}>
                    {"."}
                </span>
            </div>
        </div>
    );
}